module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "color": "grey lighten-4"
    }
  }, [(_vm.statementRequest.loading) ? _c('v-progress-linear', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "height": 2,
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-navigation-drawer', {
    attrs: {
      "bottom": "",
      "touchless": "",
      "hide-overlay": "",
      "width": "420",
      "absolute": _vm.$vuetify.breakpoint.xs,
      "permanent": !_vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "height": "100%"
    }
  }, [_c('active-clients', {
    attrs: {
      "with-close": _vm.$vuetify.breakpoint.xs
    },
    on: {
      "selected": _vm.setSelectedClient,
      "close": function($event) {
        _vm.drawer = false
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "min-height": "600px"
    },
    attrs: {
      "xs12": ""
    }
  }, [(_vm.selectedClient && _vm.selectedClient.id) ? _c('statement', {
    attrs: {
      "is-compact": _vm.$vuetify.breakpoint.xs,
      "with-filters": false,
      "client": _vm.selectedClient,
      "filter-from-date": this.globalActiveDateRange.from,
      "filter-to-date": this.globalActiveDateRange.to,
      "with-selectable": true,
      "with-reload": true,
      "with-pre-next": false,
      "loading": _vm.statementRequest.loading
    },
    on: {
      "prev": function($event) {
        _vm.activeIndex--
      },
      "next": function($event) {
        _vm.activeIndex++
      },
      "dateRangeChangeRequested": _vm.launchDateRangePicker,
      "reload": _vm.getStatement,
      "selected:list": _vm.updateSelectedAppointments
    },
    model: {
      value: (_vm.statement),
      callback: function($$v) {
        _vm.statement = $$v
      },
      expression: "statement"
    }
  }, [_c('v-toolbar-side-icon', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "slot": "toolbar-icon"
    },
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    },
    slot: "toolbar-icon"
  })], 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "subheading"
  }, [_vm._v("\n          Choose a customer to view a summary of their appointments between "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.globalActiveDateRangeFormatted))])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.launchDateRangePicker
    }
  }, [_vm._v("Change dates")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21c5d374","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Financials.vue
// module id = 1353
// module chunks = 9